import { telegramOidcStart } from '../api/auth';

export const TELEGRAM_OIDC_FLOW_KEY = 'vbbplay.telegram_oidc_flow';

/** Redirect to Telegram OIDC; the binding stays in this tab so only this browser can finish. */
export async function beginTelegramOidc(purpose: 'login' | 'link'): Promise<void> {
  const { authorization_url, binding } = await telegramOidcStart(purpose);
  sessionStorage.setItem(TELEGRAM_OIDC_FLOW_KEY, JSON.stringify({ binding, purpose }));
  window.location.assign(authorization_url);
}
